const config =  { 
    apiEndpoint: "https://csclub.uwaterloo.ca/~phthakka/1pt-express",
    googleClientId: "390807156696-81im0djtu4i4dhkkpl53lp8rgitqip6j.apps.googleusercontent.com"
}

export default config;